import React, { Component } from 'react'
import EntityList from './../../components/entityList';
import TrailerKijijiEdit from './trailer.kijijiEdit';
import FloatingActionButton from 'material-ui/FloatingActionButton';
import Snackbar from 'material-ui/Snackbar';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';

import SendIcon from 'material-ui/svg-icons/content/send';

import utils from '../../misc/utils';
var config = utils.getConfig();

const Styles = {
  sendKijijiButton: {
    margin: 0,
    top: 'auto',
    right: 50,
    bottom: 50,
    left: 'auto',
    position: 'fixed',
  }
};

class TrailersKijiji extends Component {
  constructor(props, context) {
    super(props, context);

    this.onSendConfirm = this.onSendConfirm.bind(this);
    this.sendKijijiConfirm = this.sendKijijiConfirm.bind(this);
    this.closeConfirmSendDialog = this.closeConfirmSendDialog.bind(this);
    this.sendKijiji = this.sendKijiji.bind(this);
    this.handleSendResultRequestClose = this.handleSendResultRequestClose.bind(this);

    this.state = {
      sendResultOpen: false,
      sendResultMessage: '',
      sendConfirmDialogOpen: false,
      sendConfirmTrailersCount: 0,
    };
  }

  onSendConfirm(accepted){
    if(accepted){
      this.sendKijijiConfirm();
    }

    this.setState({
      sendConfirmDialogOpen: false,
    });
  }

  sendKijiji(){
    utils.getDataFromApi('api/trailers?action=getKijijiCount', (result) => {
      this.setState({
        sendConfirmTrailersCount: result.Count,
        sendConfirmDialogOpen: true
      });
    }, () => {
      this.setState({
        sendResultMessage: 'Une erreur est survenue',
        sendResultOpen: true
      });
    });
  }

  sendKijijiConfirm(){
    utils.getDataFromApi('api/trailers?action=sendKijiji', () => {
      this.setState({
        sendResultMessage: 'L\'envoi est en cours de traitement',
        sendResultOpen: true
      });
    }, () => {
      this.setState({
        sendResultMessage: 'Une erreur est survenue',
        sendResultOpen: true
      });
    });
  }

  handleSendResultRequestClose(){
    this.setState({
      sendResultOpen: false,
      sendResultMessage: ''
    });
  };

  closeConfirmSendDialog(){
    this.setState({sendConfirmDialogOpen: false});
  }

  render() {
    return (
      <div>
        <Dialog
          modal={false}
          open={this.state.sendConfirmDialogOpen}
          onRequestClose={this.closeConfirmSendDialog}
          actions={
            [
              <FlatButton
                label="Annuler"
                primary={true}
                onTouchTap={() => this.onSendConfirm(false)}
              />,
              <FlatButton
                label="Ok"
                primary={true}
                keyboardFocused={true}
                onTouchTap={() => this.onSendConfirm(true)}
              />,
            ]
          }>
          {this.state.sendConfirmTrailersCount} remorques seront envoyées. Voulez-vous continuer?
        </Dialog>
        <EntityList apiRoute='api/trailers' baseCriteria='count=1000&scope=active' editComponent={TrailerKijijiEdit} title='Kijiji' editTitle='Kijiji' allowEdit={false} allowAdd={false} allowDelete={false} defaultOrderBy='-KijijiActive' displayColumns={[
          {Description: 'Actif sur Kijiji', Column: 'KijijiActive', sortable: true, format: {type: 'boolean', inlineEdit: true}},
          {Description: 'No. inventaire', Column: 'ProductNumber'},
          {Description: 'No. modèle', Column: 'ModelNumber'},
          {Description: 'Modèle', Column: 'TrailerModel', format: {type: 'relation', displayColumn: 'Description'}},
          {Description: 'Marque', Column: 'Make', format: {type: 'relation', displayColumn: 'Description'}},
          {Description: 'Année', Column: 'Year'},
          {Description: 'Prix', Column: 'Price', format: {type: 'money'}},
        ]}/>
        <FloatingActionButton onClick={this.sendKijiji} style={Styles.sendKijijiButton}>
          <SendIcon />
        </FloatingActionButton>
        <Snackbar
          open={this.state.sendResultOpen}
          message={this.state.sendResultMessage}
          onRequestClose={this.handleSendResultRequestClose}
          autoHideDuration={4000}
        />
      </div>
    )
  }
}

export default TrailersKijiji;


/** WEBPACK FOOTER **
 ** ./src/app/routes/trailers/trailers.kijiji.js
 **/